import React from 'react';
import { IPlayer } from 'interfaces/team/IPlayer';
import { playerToPlayerFullNameMap } from 'services/helper-services/mappingHelpers/playerMappings';
import { Player, SubstitutionPlayerWrapper } from './SubstitutionPlayerStyles';

interface IProps {
  player: IPlayer;
  onClickPlayerCallback: (player: IPlayer) => void;
  index: number;
}

export const SubstitutionPlayer: React.FC<IProps> = (props) => {
  const { player, onClickPlayerCallback, index } = props;
  return (
    <SubstitutionPlayerWrapper onClick={() => onClickPlayerCallback(player)} data-testid={`substitution-player-${index}`}>
      <Player>
        {playerToPlayerFullNameMap(player)} {player.jerseyNumber ? `#${player.jerseyNumber}` : ''}
      </Player>
    </SubstitutionPlayerWrapper>
  );
};
